import { render, staticRenderFns } from "./RegestModal.vue?vue&type=template&id=7bc19bf7&"
import script from "./RegestModal.vue?vue&type=script&lang=js&"
export * from "./RegestModal.vue?vue&type=script&lang=js&"
import style0 from "./RegestModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports